import _ from "lodash";
import * as type from "./types";
export default (state = {}, action) => {
  switch (action.type) {
    case type.FETCH_LEAVE_BALANCES:
      return { ..._.mapKeys(action.payload, "Id") };
    case type.FETCH_LEAVE_BALANCE:
      return { ...state, [action.payload.Id]: action.payload };
    case type.EDIT_LEAVE_BALANCE:
      return { ...state, [action.payload.Id]: action.payload };
    default:
      return state;
  }
};
